/**
 * The locale a URL prefix selects, defaulting to en-US for the unprefixed
 * (primary) language.
 */
export const localeFromPrefix = (prefix: string | undefined): string => {
  if (prefix === '/uk') {
    return 'ua-UK';
  }
  if (prefix === '/ru') {
    return 'ru-RU';
  }
  return 'en-US';
};

/**
 * One cookie's value, empty when it is not set.
 */
export const getCookieValue = (name: string): string => {
  const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
  return match?.[2] ?? '';
};
